<template>
  <!-- see: https://codepen.io/leeshin/pen/oMoPZe -->
  <div class="range-slider">
    <div class="track-container">
      <span class="range-value min">{{ minValue}}%</span> <span class="range-value max">{{ maxValue }}%</span>
      <div class="track" ref="_vpcTrack"></div>
      <div class="track-highlight" ref="trackHighlight"></div>
      <button class="track-btn track1" ref="track1"></button>
      <button class="track-btn track2" ref="track2"></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RangeSlider',
  props: {
    // [min, max] — declared as Object before, which contradicted both the
    // default below and the index-based use in mounted().
    startValues: {
      type: Array,
      required: true,
      default: function () {
        return [0, 100]
      }
    }
  },
  data () {
    return {
      min: 0,
      max: 100,
      minValue: 0,
      maxValue: 100,
      step: 1,
      totalSteps: 0,
      percentPerStep: 1,
      trackWidth: null,
      isDragging: false,
      pos: {
        curTrack: null
      }
    }
  },
  methods: {
    moveTrack (track, ev) {
      const percentInPx = this.getPercentInPx()
      const trackX = Math.round(this.$refs._vpcTrack.getBoundingClientRect().left)
      const clientX = ev.clientX
      const moveDiff = clientX - trackX

      const moveInPct = moveDiff / percentInPx
      // console.log(moveInPct)

      if (moveInPct < 1 || moveInPct > 100) return
      const value = (Math.round(moveInPct / this.percentPerStep) * this.step) + this.min
      if (track === 'track1') {
        if (value >= (this.maxValue - this.step)) return
        this.minValue = value
      }

      if (track === 'track2') {
        if (value <= (this.minValue + this.step)) return
        this.maxValue = value
      }

      this.$refs[track].style.left = moveInPct + '%'
      this.setTrackHightlight()

      this.$emit('rangeUpdate', [this.minValue, this.maxValue])
    },
    mousedown (ev, track) {
      if (this.isDragging) return
      this.isDragging = true
      this.pos.curTrack = track
    },

    touchstart (ev, track) {
      this.mousedown(ev, track)
    },

    mouseup (ev, track) {
      if (!this.isDragging) return
      this.isDragging = false
    },

    touchend (ev, track) {
      this.mouseup(ev, track)
    },

    mousemove (ev, track) {
      if (!this.isDragging) return
      this.moveTrack(track, ev)
    },

    touchmove (ev, track) {
      this.mousemove(ev.changedTouches[0], track)
    },

    valueToPercent (value) {
      return ((value - this.min) / this.step) * this.percentPerStep
    },

    setTrackHightlight () {
      this.$refs.trackHighlight.style.left = this.valueToPercent(this.minValue) + '%'
      this.$refs.trackHighlight.style.width = (this.valueToPercent(this.maxValue) - this.valueToPercent(this.minValue)) + '%'
    },

    getPercentInPx () {
      const trackWidth = this.$refs._vpcTrack.offsetWidth
      const oneStepInPx = trackWidth / this.totalSteps
      // 1 percent in px
      const percentInPx = oneStepInPx / this.percentPerStep
      return percentInPx
    },

    setClickMove (ev) {
      const track1Left = this.$refs.track1.getBoundingClientRect().left
      const track2Left = this.$refs.track2.getBoundingClientRect().left
      // console.log('track1Left', track1Left)
      if (ev.clientX < track1Left) {
        this.moveTrack('track1', ev)
      } else if ((ev.clientX - track1Left) < (track2Left - ev.clientX)) {
        this.moveTrack('track1', ev)
      } else {
        this.moveTrack('track2', ev)
      }
    }
  },
  mounted () {
    // calc per step value
    this.totalSteps = (this.max - this.min) / this.step

    // percent the track button to be moved on each step
    this.percentPerStep = 100 / this.totalSteps
    // console.log('percentPerStep', this.percentPerStep)

    // set track1 initial position
    // 'lenght' was a typo, so this test never passed and the lower track always
    // started at 0 instead of at the value the parent handed in.
    this.minValue = this.startValues && this.startValues.length === 2 ? this.startValues[0] : 0
    // console.log('RangeSlider#mounted minValue : ' + this.minValue)
    document.querySelector('.track1').style.left = this.valueToPercent(this.minValue) + '%'
    // set track2 initial position
    this.maxValue = this.startValues && this.startValues.length === 2 ? this.startValues[1] : 0
    // console.log('RangeSlider#mounted maxValue : ' + this.maxValue)
    document.querySelector('.track2').style.left = this.valueToPercent(this.maxValue) + '%'
    // set initila track highlight
    this.setTrackHightlight()

    const self = this

    const mouse = ['mouseup', 'mousemove']
    mouse.forEach(type => {
      document.body.addEventListener(type, (ev) => {
        // ev.preventDefault()
        if (self.isDragging && self.pos.curTrack) {
          self[type](ev, self.pos.curTrack)
        }
      })
    })

    const mouseandmore = ['mousedown', 'mouseup', 'mousemove', 'touchstart', 'touchmove', 'touchend']
    mouseandmore.forEach(type => {
      document.querySelector('.track1').addEventListener(type, (ev) => {
        ev.stopPropagation()
        self[type](ev, 'track1')
      })

      document.querySelector('.track2').addEventListener(type, (ev) => {
        ev.stopPropagation()
        self[type](ev, 'track2')
      })
    })

    // on track clik
    // determine direction based on click proximity
    // determine percent to move based on track.clientX - click.clientX
    document.querySelector('.track').addEventListener('click', function (ev) {
      ev.stopPropagation()
      self.setClickMove(ev)
    })

    document.querySelector('.track-highlight').addEventListener('click', function (ev) {
      ev.stopPropagation()
      self.setClickMove(ev)
    })
  }
}
</script>

<style lang="scss" scoped>

  .range-slider {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .range-value{
    position: absolute;
    top: -2rem;
  }
  .range-value.min{
    left: 0;
  }

  .range-value.max{
    right: 0;
  }

  .track-container{
    width: 100%;
    position: relative;
    cursor: pointer;
    height: 0.5rem;
  }

  .track,
  .track-highlight {
    display: block;
    position: absolute;
    width: 100%;
    height: 0.5rem;
  }

  .track{
    background-color: #ddd;
  }

  .track-highlight{
    background-color: #A9A9A9;
    z-index: 2;
  }

  .track-btn{
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    outline: none;
    cursor: pointer;
    display: block;
    position: absolute;
    z-index: 2;
    width: 1.5rem;
    height: 1.5rem;
    top: calc(-50% - 0.25rem);
    margin-left: -1rem;
    border: 0;
    background-color: #fff;
    border-radius: 50%;
    box-shadow: .5px .5px 2px 1px rgba(0,0,0,.32);
    -ms-touch-action: pan-x;
    touch-action: pan-x;
    transition: box-shadow .3s ease-out,background-color .3s ease,-webkit-transform .3s ease-out;
    transition: transform .3s ease-out,box-shadow .3s ease-out,background-color .3s ease;
    transition: transform .3s ease-out,box-shadow .3s ease-out,background-color .3s ease,-webkit-transform .3s ease-out;
  }

</style>
